import { Badge, Loader } from '@mantine/core';
import React from 'react';
import { BackgroundProcessStatus } from 'src/data-capture/hooks/file-uploads/types';

type Props = {
  status: BackgroundProcessStatus;
};

const StatusMap = {
  PENDING: {
    variant: 'processing',
    text: 'Generating...',
    showLoader: true,
  },
  PROCESSING: {
    variant: 'processing',
    text: 'Generating...',
    showLoader: true,
  },
  SUCCESS: {
    variant: 'success',
    text: 'Ready',
    showLoader: false,
  },
  FAILED: {
    variant: 'error',
    text: 'Failed',
    showLoader: false,
  },
};

export default function SuitabilityReportStatusPill({ status }: Props) {
  const { variant, text, showLoader } = StatusMap[status];

  return (
    <Badge
      variant={variant}
      style={{
        borderRadius: 4,
        textTransform: 'none',
        fontWeight: 500,
      }}
      size={'lg'}
      px={'xxs'}
      leftSection={showLoader && <Loader size={8} color={'gray.8'} />}
    >
      {text}
    </Badge>
  );
}
